import { useFormStore } from '@/stores/form'
import router from '@/router'
import { useI18n } from 'vue-i18n'
import { useGlobalStore } from '@/stores/global'
import bulkFileApi from '@/services/bulkFile'
import apiHelperService from '@/services'

const checkUnifiedNumber = () => {
  const formStore = useFormStore()
  const { personUnifiedNumber, departmentCode } = formStore.form.values
  if (!personUnifiedNumber && !departmentCode) {
    formStore.extraMap.showUnifiedNumber = true
    formStore.extraMap.showFileNumber = false
  } else {
    if (personUnifiedNumber) {
      formStore.extraMap.showUnifiedNumber = true
      formStore.extraMap.showFileNumber = false
    } else {
      formStore.extraMap.showUnifiedNumber = false
      formStore.extraMap.showFileNumber = true
    }
  }
}

const checkConductIdentificationCodeCertificate = async () => {
  const formStore = useFormStore()
  const { showConductIdentificationCodeCertificate } = formStore.extraMap
  const { dateOfBirth, currentNationalityId, passportNumber, passportTypeId, personUnifiedNumber } =
    formStore.form.values
  const hasNationalityPassportDetails = currentNationalityId && passportNumber && passportTypeId
  if (
    showConductIdentificationCodeCertificate &&
    dateOfBirth &&
    (hasNationalityPassportDetails || personUnifiedNumber)
  ) {
    try {
      const payload = {
        unifiedNumber: personUnifiedNumber,
        passportNumber,
        passportTypeId,
        currentNationalityId,
        dateOfBirth
      }
      const res = await apiHelperService.post(
        '/api/requestmaster/showConductIdentificationCodeCertificate',
        payload
      )
      if (res && res !== null) {
        formStore.extraMap.showConductIdentificationCodeCertificate = res
      } else {
        formStore.form.setValues({
          conductIdentificationCodeCertificate: null
        })
      }
    } catch (error) {
      formStore.form.setValues({
        conductIdentificationCodeCertificate: null
      })
      console.error('checkConductIdentificationCodeCertificate', error)
    }
  }
}

const checkSponsorRule = async ({ source: module } = {}) => {
  const formStore = useFormStore()
  const { personUnifiedNumber } = formStore.form.values
  if (module == 1) {
    if (!personUnifiedNumber) return
    await CheckFines()
    checkUnifiedNumber()
    await checkConductIdentificationCodeCertificate()
  }
}

const CheckFines = async () => {
  const globalStore = useGlobalStore()
  const formStore = useFormStore()
  if (!globalStore.startedService.serviceConfig.enableFinesOnPermitLeaving) {
    formStore.extraMap = {
      ...formStore.extraMap,
      finesWarningMessage: '',
      showFinesWarningMessage: false
    }
  }
  const serviceTransactionId = router.currentRoute.value.params.serviceId
  const {
    sponsorUnifiedNumber,
    personUnifiedNumber,
    departmentCode,
    serviceYear,
    serviceCode,
    sequenceNumber,
    sponsorTypeId,
    sponsorImmigrationId
  } = formStore?.form.values || {}
  const params = {
    sponsorUnifiedNumber,
    personUnifiedNumber,
    departmentCode,
    serviceYear,
    serviceCode,
    sequenceNumber,
    sponsorTypeId,
    sponsorImmigrationId,
    serviceTransId: serviceTransactionId || 919
  }
  const queryLoad = Object.keys(params).reduce((acc, key) => {
    if (params[key]) {
      acc[key] = params[key]
    }
    return acc
  }, {})
  const response = await bulkFileApi.violatedFiles(queryLoad)
  if (response && response.length > 0) {
    let files = ''
    const i18n = useI18n()
    formStore.extraMap.showchangeStatusMessage = false
    formStore.extraMap.showFinesMessage = false
    response.map((value) => {
      files = [
        value.departmentCode,
        value.serviceYear,
        value.serviceCode,
        value.sequenceNumber
      ].join(' , ')

      if (value.newVisaSequenceNumber) {
        formStore.extraMap.showchangeStatusMessage = true
        formStore.extraMap.changeStatusMessage = i18n.global.t('changeStatusMessage')
      }

      if (value.sequenceNumber) {
        if (globalStore.startedService.serviceConfig.multipleRequest) {
          formStore.extraMap = {
            ...formStore.extraMap,
            showFinesWarningMessage: true,
            finesWarningMessage: [
              i18n.global.t('existViolatedFiles1'),
              ':',
              files,
              i18n.global.t('existViolatedFiles2')
            ].join(' ')
          }
        } else {
          formStore.extraMap = {
            ...formStore.extraMap,
            finesWarningMessage: [
              i18n.global.t('existViolatedFilesWithAutoReq1'),
              ':',
              files,
              i18n.global.t('existViolatedFilesWithAutoReq2')
            ].join(' ')
          }
        }
      }
    })
  }
}
export default function () {
  return {
    checkSponsorRule,
    checkConductIdentificationCodeCertificate
  }
}
